<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">{{ TypeCode === 'Earn' ? 'Gelir' : 'Gider' }} Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Balance" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Muhasebe</span>
        </b-btn>
      </b-col>
    </b-row>

    <form @submit.prevent="AddBalance">
      <b-form-group class="formgroup" label="Açıklama">
        <b-form-input type="text" v-model="Balance.Name" @keypress.enter.prevent="AddBalance"></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup" label="Miktar">
        <b-form-input type="number" v-model="Balance.Amount" @keypress.enter.prevent="AddBalance"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Açıklama",
        Amount: "Miktar"
      },
      TypeCode: "Earn",
      Balance: {
        Name: "",
        Amount: 0
      }
    };
  },
  computed: {
    ...mapState(["ButtonSize"])
  },
  methods: {
    async AddBalance() {
      this.$store.dispatch("AddLoading", "AddBalance");

      await Services.Nozich.Send(
        "AddBalance",
        {
          TypeCode: this.TypeCode,
          Balance: this.Balance
        },
        Data => {
          this.$store.dispatch("RemoveLoading", "AddBalance");

          if (Data.Status === "Success") {
            this.$router.go(-1);
          }
        }
      );
    }
  },
  async mounted() {
    await this.$set(this, "TypeCode", this.$route.params.TypeCode);

    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
